import { CostBomDemoInner } from '~/widgets/CostBomDemo/CostBomDemoInner'
import { WidgetWrapper, WidgetProps } from '~/widgets/shared'

interface CostBomDemoProps extends WidgetProps {
  title?: string
}

export function CostBomDemo({
  title: _title = 'Muir cost model demo',
  ...wrapperProps
}: CostBomDemoProps) {
  return (
    <WidgetWrapper {...wrapperProps} height="auto">
      <CostBomDemoInner />
    </WidgetWrapper>
  )
}
